// Application constants

function parseOrgIds(raw: string | undefined): string[] {
  return (raw ?? '')
    .split(',')
    .map((s: string) => s.trim())
    .filter(Boolean);
}

// Orgs granted access to admin features (admin console, ontology, asset
// admin actions). Sourced from VITE_ADMIN_ORG_IDS as a comma-separated list.
export const ADMIN_ORG_IDS: readonly string[] = parseOrgIds(import.meta.env.VITE_ADMIN_ORG_IDS);

export function isAdminOrg(orgId: string | null | undefined): boolean {
  return !!orgId && ADMIN_ORG_IDS.includes(orgId);
}

// Orgs allowed to use Demo Mode (scenario filtering presets in Settings).
// Distinct from ADMIN_ORG_IDS so we can extend demo access without granting
// full admin powers. Sourced from VITE_DEMO_MODE_ORG_IDS as a comma-separated
// list; admin orgs are always included.
export const DEMO_MODE_ORG_IDS: readonly string[] = Array.from(
  new Set([...parseOrgIds(import.meta.env.VITE_DEMO_MODE_ORG_IDS), ...ADMIN_ORG_IDS])
);

export function isDemoModeAllowed(orgId: string | null | undefined): boolean {
  return !!orgId && DEMO_MODE_ORG_IDS.includes(orgId);
}
